<template>
    <div id="provider-panel-container">
        <MdTitle v-if="label" v-bind:Text="label" v-bind:isSubtitle="true" v-bind:Name="'T_PROVIDER_SUBTITLE'"/>
        <b-row>
            <b-col class="col-sm-12 col-md-3">                      
                <MdButton
                    v-bind:Label="$t('employee.AddProviderID')" 
                    v-bind:ClassProp="isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"              
                    v-on:click="callModalProvider"
                    v-bind:isReadOnly="isReadOnly">
                </MdButton>
            </b-col>
            <b-col class="col-sm-12 col-md-9 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input 
                            type="text" 
                            class="form-control"
                            :dir="dirInput"
                            v-model="searchProvider"   
                            @keyup.enter="findProvider" />
                        <div class="input-group-append">
                            <div class="input-group-append">
                                <MdButton 
                                    v-bind:Name="'btnsearchinputProvider'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="findProvider">
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-md-12">
                <MdTablePaginationClient 
                    v-bind:fields="fieldsProvider"
                    v-bind:items="providerCodesListFilter"
                    v-bind:totalRows="totalRowsProvider"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmptyProviders"
                    v-bind:currentPage="currentPageProvider"
                    v-bind:perPage="perPageProvider"
                    v-bind:pageOptions="pageOptionsProvider"  
                    v-bind:IsItemReceived="false"                    
                    :onRowSelected="onRowSelectedProvider"
                    :onFiltered="onFilteredProvider"
                    :pageChanged="pageChangedProvider"
                    :perPageFunction="PerPageFunctionProvider" 
                    :VisibleDeleteIcon="true"
                    :deleteIconEvent="RemoveProvider"
                    :VisibleEditIcon="true"
                    :editIconEvent="EditProvider"
                    :RowClick="RowClick"
                >
                </MdTablePaginationClient>
            </b-col>
        </b-row>

        <EmployeeProviderModal
            :visible.sync="visibleProviderModal"
            v-model="editableProvider"
            :insuranceList="insuranceList"
            :editMode="editableItemMode"
            @ok="saveProvider"
        >
        </EmployeeProviderModal>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import EmployeeProviderModal from './employeeProviderModal.vue';

export default {
    name: 'ProviderPanel',
    mixins: [ShowMessage, DBFunctions],

    props: {
        value: {
            type: Array,
            default: () => []
        },
        isReadOnly: {
            type: Boolean,
            default: false
        },
        insuranceList: {
            type: Array,
            required: true
        },
        label: {
            type: String
        }
    },

    components: {
        EmployeeProviderModal
    },

    data() {
        return {
            editableItem: this.value || [],
            searchProvider: "",
            search: {
                provider: '',
            },
            fieldsProvider:[
                { key: 'companyName', sortable: true, label: this.$t('employee.Company'), class: 'text-rigth'},
                { key: 'providerId', sortable: true, label: this.$t('Shared.ProviderId'), class: 'text-rigth'}, 
            ],
            currentPageProvider: 1,
            perPageProvider: 10,
            pageOptionsProvider: [5,10,15],
            editableProvider: {
                code: '',
                insuranceCode: '',
                providerId: '',
                companyName: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            editableItemMode: false,
            visibleProviderModal: false
        }
    },

    computed: {
        providerCodesListFilter() {
            const search = (this.search.provider || '').trim().toLowerCase();
            const list = this.editableItem;

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.companyName || '').toLowerCase();
                const id = (item.providerId || '').toLowerCase();
                
                return name.includes(search) || id.includes(search);
            });
        },

        totalRowsProvider() {
            return this.providerCodesListFilter.length;
        },

        showMessageIsEmptyProviders() {
            return this.totalRowsProvider === 0;
        },
    },

    watch: {
        value(newValue) {
            this.editableItem = newValue || [];
        }
    },

    methods: {
        callModalProvider(){
            this.editableProvider = {
                code: '',
                insuranceCode: '',
                providerId: '',
                companyName: ''
            };
            this.editableItemMode = false;
            this.visibleProviderModal = true;
        },

        findProvider(){
            this.search.provider = this.searchProvider;
            this.currentPageProvider = 1;
        },

        EditProvider(value) {
            this.editableItemMode = true;
            this.editableProvider = value;
            this.visibleProviderModal = true;
        },

        RemoveProvider(itemToRemove){
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_provider'
				})
                .then(value => {
                    if (value) {
                        const index = this.editableItem.findIndex(item => item === itemToRemove);
        
                        if (index !== -1) {
                            this.editableItem.splice(index, 1);
                            this.emitChanged('provider');
                            
                            if (this.currentPageProvider > (this.totalRowsProvider / this.perPageProvider)) {
                                this.currentPageProvider--;
                            }
                        }
                    }
                });
        },

        PerPageFunctionProvider(value){
            this.perPageProvider = value;

            if (this.currentPageProvider > (this.totalRowsProvider / this.perPageProvider)) {
                this.currentPageProvider = 1;
            }
        },

        pageChangedProvider(value){
            this.perPageProvider = value;
        },

        onRowSelectedProvider(){

        },

        onFilteredProvider(){
        
        },

        saveProvider(value) {
            if (!this.editableItemMode) {
                const insuranceCode = (value.insuranceCode || '').toLowerCase();
                const index = this.editableItem.findIndex(item => {
                    const code = (item.insuranceCode || '').toLowerCase();
                    
                    return (insuranceCode === code);
                });

                if (index === -1) {
                    this.editableItem.push(value);
                    this.emitChanged('provider');
                }
            } else {
                const index = this.editableItem.findIndex(item => item === this.editableProvider);
        
                if (index !== -1) {
                    this.$set(this.editableItem, index, value);
                    this.emitChanged('provider');
                }
            }
        },

        RowClick() {

        },

        emitChanged(componentName) {
            const changed = {
                "Changed":true,
                "ComponentName": componentName,
            } 
        
            EventBus.$emit('onChanged', changed);
        }
    }
}
</script>